import React from "react";

export const PageNotFound = () => {
  return <div style={{fontFamily:'Open Sans'}}>We are sorry we can' find the page you are looking for.</div>;
};
